import { ReactQueryDynamicDevTools } from '@quickmd-llc/design-system';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { isDevToolsEnabled } from 'features/devtools/isDevToolsEnabled';
import { PropsWithChildren } from 'react';

const queryClient = new QueryClient();

export function ReactQueryProvider({ children }: PropsWithChildren) {
  return (
    <QueryClientProvider client={queryClient}>
      <ReactQueryDynamicDevTools isDevToolsEnabled={isDevToolsEnabled()} />
      {children}
    </QueryClientProvider>
  );
}
